import {useRef,useState} from 'react';
// Tab-local, scoped by verified account + organization + activity. No backend write.
const fallback=new Map();
export default function useOperationDrafts(scope){
 const key=scope?'tps:operations:'+scope:null;
 const [storageError,setStorageError]=useState(false);
 const [items,setItems]=useState(()=>{
  if(!key)return {};
  try{const saved=JSON.parse(sessionStorage.getItem(key)||'null');if(saved?.version===1&&saved.items&&typeof saved.items==='object')return saved.items;return {};}catch{return fallback.get(key)||{};}
 });
 const current=useRef(items);
 const commit=next=>{
  current.current=next;setItems(next);
  if(!key)return;
  fallback.set(key,next);
  try{if(Object.keys(next).length)sessionStorage.setItem(key,JSON.stringify({version:1,dirty:true,items:next}));else sessionStorage.removeItem(key);setStorageError(false);}catch{setStorageError(true);}
 };
 const put=(id,row)=>commit({...current.current,[id]:{...row,updated_at:new Date().toISOString()}});
 const update=(id,fn)=>{const row=current.current[id];if(row)put(id,typeof fn==='function'?fn(row):{...row,...fn});};
 const remove=id=>{const next={...current.current};delete next[id];commit(next);};
 const request=(id,url,body)=>{
  const row=current.current[id],fingerprint=JSON.stringify([url,body]);
  if(row?.pending?.fingerprint===fingerprint)return row.pending.id;
  const value=crypto.randomUUID();if(row)put(id,{...row,pending:{fingerprint,id:value}});return value;
 };
 return {items,put,update,remove,request,get:id=>current.current[id],storageError};
}
